import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'


const url = 'v1/tandc'
const plural = 'v1/tandcs'
const single = 'v1/tandc'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})


api.getTnC = (payload) => {

	return axios
		.get(`${apiProvider.BASE_URL}/v1/tandc/template`,payload)
		.then(handleResponse)
		.catch(handleError);
}

api.acceptTnC = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/tandc/status`,payload)
		.then(handleResponse)
		.catch(handleError);
}

export default api
